export default "__VITE_ASSET__Zrel11rq__"